import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button, CircularProgress } from '@mui/material';
import PrivateWrapper from '../layouts/Private';
import { UpdateInventory } from '../services/Affiliates';
import useToastr from '../hooks/useToastr';

const InventorySync = () => {
  const [processing, setProcessing] = useState(false);
  const { showErrorToastr, showSuccessToastr } = useToastr();
  const updateInventoryHandler = async () => {
    setProcessing(true);
    const res = await UpdateInventory();

    const { status, msg } = await res;
    if (status === 200) showSuccessToastr('Inventory sync successfull.');
    else showErrorToastr(msg);
    setProcessing(false);
  };
  return (
    <PrivateWrapper pageName="Sync Inventory">
      <Box
        height="90vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <Typography variant="h5">
          <Button
            onClick={updateInventoryHandler}
            style={{ border: '1px solid' }}
            endIcon={processing && <CircularProgress size={18} />}
          >
            {' '}
            SYNC INVENTORY
          </Button>
        </Typography>
      </Box>
    </PrivateWrapper>
  );
};

export default InventorySync;
